import React, { ReactElement } from 'react';
import FormatService from '../../services/format-service';
import FlexContainer from '../flex-container/flex-container.component';
import useScreenSmall from '../../hooks/use-screen-small';
import useStylesControlContainer from './control-container.styles';

const ControlContainer: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isHidden,
    isMultiline,
    children,
  } = props;

  const { classes } = useStylesControlContainer();
  const isSmallScreen: boolean = useScreenSmall();

  const hiddenClassName: string | undefined = isHidden ? classes.controlContainerHidden : undefined;

  return (
    <FlexContainer
      isColumn={isMultiline && isSmallScreen}
      className={FormatService.formatClassNames(classes.controlContainer, hiddenClassName)}
    >
      {children}
    </FlexContainer>
  );
});

export default ControlContainer;
